import { http } from '../utils/http';

export function me(signal) {
    return http.get('/me', { signal });
}

export function login(email, password, signal) {
    return http.post('/login', { email, password }, { signal });
}

export function firstLoginResetPassword(token, newPassword, signal) {
    return http.post(
        '/first-login/reset-password',
        { token, new_password: newPassword },
        { signal }
    );
}

export function logout(signal) {
    return http.get('/logout', {}, { signal });
}

export const getTelegramToken = (signal) => http.get('/telegram/token', { signal });

export const sendTestEmail = (signal) =>
    http.post('/notifications/test-email', {}, { signal });

export function resetPassword(currentPassword, newPassword, signal) {
    return http.put(
        '/reset-password',
        {
            current_password: currentPassword,
            new_password: newPassword,
        },
        { signal }
    );
}

// Legacy snake_case exports kept for older imports
export { getTelegramToken as get_tg_token, sendTestEmail as send_test_email };
export { firstLoginResetPassword as first_login_reset_password };
